import * as Styled from './styles'

export default function ButtonPage({ children, link }) {
  return <Styled.ButtonPage onClick={link}>{children}</Styled.ButtonPage>
}
